import type VariableId from "../variables/VariableId";

class VariableShowEvent extends Event {
  public readonly variableId: VariableId;

  constructor(variableId: VariableId) {
    super(`variable.show-${variableId.toString()}`, { bubbles: false });
    this.variableId = variableId;
  }

  send() {
    setTimeout(() => document.dispatchEvent(this));
  }
}

export default VariableShowEvent;
